import React, {Component} from 'react';
import {connect} from 'react-redux';
import {logout} from '../../actions/users';
import View from './View';

class AdminMenu extends Component {


    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false
        };
    }

    render() {
        return (
            <div>
                <View
                    {...this.props}
                    {...this.state}
                    logout={this.props.logout}
                />
            </div>
        );
    }
}

/**
 * Map actions to properties
 */
const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(logout())
    }
};

export default connect(null, mapDispatchToProps)(AdminMenu);



// WEBPACK FOOTER //
// ./src/components/AdminMenu/index.js